module.exports = __webpack_public_path__ + "assets/clear_search-496fcb.svg";